<template>
    <div class="card h-100">
        <div class="card-header">
            <i class="fa-solid fa-bag-shopping"></i> Ventas
        </div>
        <div class="card-body">
            <form>
                <div class="form-group row">
                    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <base-select-forms v-model="formData.codAlmacen" title="Almacenes" idSelect="codAlmacen"
                            :options="shopAuthorizedLists" optionName="nombreAlmacen" optionId="codAlmacen"
                            :errors="alert.errorsFields" :onChange="loadGraphics"></base-select-forms>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <base-select-forms v-model="formData.tipoRangoFecha" title="Fecha"
                            idSelect="tipoRangoFechaSolicitud" :options="reportsParameters.rangoFechaFiltro"
                            optionName="1" optionId="0" :errors="alert.errorsFields"
                            :onChange="loadGraphics"></base-select-forms>
                    </div>
                </div>
            </form>
            <widget-loading v-if="isLoading.salesGraphics" />
            <canvas v-show="!isLoading.salesGraphics" id="graphicsSales"></canvas>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-end">
                <base-button-forms classButton="btn-primary" icon="fa-solid fa-file-export" :permissionId="72"
                    :onClick="onExportToExcel" :isLoading="isLoading['salesGraphicsExport']"
                    :disabled="isLoading['salesGraphicsExport']"></base-button-forms>
            </div>
        </div>
    </div>
</template>

<script>

import { ref, computed, onMounted } from 'vue'
import Chart from 'chart.js/auto';


import useReports from '@/modules/reports/composables/useReports'
import graphics from '@/helpers/graphics'
import WidgetLoading from '@/common/widgets/WidgetLoading.vue';
import BaseSelectForms from '@/common/forms/BaseSelectForms.vue';
import useShop from '@/modules/shop/composables/useShop'
import BaseButtonForms from '@/common/forms/BaseButtonForms.vue';





export default {
    components: {
        WidgetLoading,
        BaseSelectForms,
        BaseButtonForms
    },

    setup() {
        const {
            getDataReports,
            salesGraphics,
            isLoading,
            alert,
            reportsParameters,
            exportToExcel
        } = useReports()

        const { barGraphicsOptions } = graphics()

        const { getShopAuthorizedLists, shopAuthorizedLists } = useShop()

        const formData = ref({
            codAlmacen: '',
            tipoRangoFecha: '0',
            tipoReporte:'VE'

        })

        let myChart
        const loadGraphics = async () => {
            try {
                if (myChart) {
                    myChart.clear();
                    myChart.destroy();
                }
                const { response } = await getDataReports(formData.value, 'salesGraphics')
                if (response) {
                    const ctx = document.getElementById('graphicsSales')
                    const opcionesGrafico = barGraphicsOptions({
                        tipoInforme: 'ventas',
                        labels: salesGraphics.value.labels,
                        datasets: salesGraphics.value.datasets,
                        titulo: salesGraphics.value.title,
                        subtitulo: salesGraphics.value.subtitle,
                        textoEjeX: 'Año',
                        textoEjeY: 'Monto ventas',
                        tipoDato: 'monto'

                    })
                    myChart = new Chart(ctx, opcionesGrafico, 'monto');
                    myChart
                }
            } catch (error) {
                console.log(error)
            }
        }

        // getShopAuthorizedLists('caja')

        onMounted(async () => {
            loadGraphics()
        })
        return {
            salesGraphics,
            isLoading,
            alert,
            formData,
            reportsParameters,
            shopAuthorizedLists,

            loadGraphics,
            onExportToExcel: async () => {
                await exportToExcel(formData.value, 'salesGraphics')
            }

        }
    },


}
</script>